import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fb962f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fila cabecera text-caption text-medium-emphasis" }, [
  /*#__PURE__*/_createElementVNode("span", null, "#"),
  /*#__PURE__*/_createElementVNode("span", null, "Jugador"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-right" }, "Circuito")
], -1))
const _hoisted_2 = { class: "text-medium-emphasis" }
const _hoisted_3 = { class: "text-right" }


import { GanadorDTO } from "@/interfaces/Ganadores";
import { puntosCircuito } from "@/utils/puntosCircuito";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalClasificacionEvento',
  props: {
    modelValue: { type: Boolean },
    evento: {},
    posiciones: {},
    idUsuario: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

const cerrar = () => emit("update:modelValue", false);

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.modelValue,
    "max-width": "480",
    scrollable: "",
    "onUpdate:modelValue": cerrar
  }, {
    default: _withCtx(() => [
      (_ctx.evento)
        ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "text-wrap pb-0" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.evento.nombreTorneo), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_subtitle, { class: "pb-2" }, {
                default: _withCtx(() => [
                  _createTextVNode("Clasificación final · " + _toDisplayString(_ctx.posiciones.length) + " jugadores", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, { class: "pt-0" }, {
                default: _withCtx(() => [
                  _hoisted_1,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posiciones, (posicion) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: posicion.idUsuario,
                      class: _normalizeClass(["fila text-body-2", { resaltada: posicion.idUsuario === _ctx.idUsuario }])
                    }, [
                      _createElementVNode("span", _hoisted_2, _toDisplayString(posicion.resultado), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(["nick", { 'font-weight-bold': posicion.idUsuario === _ctx.idUsuario }])
                      }, _toDisplayString(posicion.nick), 3),
                      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(puntosCircuito)(_ctx.posiciones.length, posicion.resultado)), 1)
                    ], 2))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    size: "small",
                    class: "text-none",
                    to: `/detalle-evento/${_ctx.evento.idTorneo}?tab=resultados`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Ver el evento ")
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    class: "text-none",
                    onClick: cerrar
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Cerrar")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})